// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postVehicle } from '../../services/VehiclesService';
import { Vehicle, PostVehicleRequest } from '../../types/Vehicles';

type Result = UseMutationResult<Vehicle, Error, PostVehicleRequest>;

function usePostVehicle(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postVehicle, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['vehicles'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostVehicle;
